import React from "react";
import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function PublicNoticeAddForm({ 
  publicNotice,
  btnRef,
  savePublicNotice
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={publicNotice}
      onSubmit={(values) => {
        const formData = new FormData();
        formData.append("fileData", values.attachment);
        formData.append("serializedData", JSON.stringify(values));
        savePublicNotice(formData);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="definition">
            <Form.Label column sm={2}>
              Tanımı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.definition} placeholder="Tanımı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="explanation">
            <Form.Label column sm={2}>
              Açıklaması<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control as="textarea" rows="3" value={values.explanation} placeholder="Açıklaması" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="attachment">
            <Form.Label column sm={2}>
              Ek
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="file" className="mt-2" onChange={e => setFieldValue("attachment", e.target.files[0])} />
              <span className="form-text text-muted">Dosya boyutu en fazla 10 MB olabilir.</span>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Gönderim Türü
            </Form.Label>
            <Col sm={10}>
              <Form.Check
                inline
                disabled={true}
                checked={true}
                type="checkbox"
                id="sendingTypeApplication"
                className="mt-3 mr-12"
                label="Uygulama"                    
              />
              <Form.Check
                inline
                type="checkbox"
                id="sendingTypeMail"
                className="mt-3 mr-12"
                label="Mail"
                onChange={e => setFieldValue("isSendingTypeMail", e.target.checked)}
              />
              <Form.Check
                inline
                type="checkbox"
                id="sendingTypeSms"
                className="mt-3"
                label="SMS"
                onChange={e => setFieldValue("isSendingTypeSms", e.target.checked)}
              />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}